import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { InstacitiLandingComponent } from "./instaciti-landing/instaciti-landing.component";
import { InstacitiListingComponent } from "./instaciti-listing/instaciti-listing.component";
import { SchoolDetailsComponent } from "./school-details/school-details.component";
import { AutomobileDetailsComponent } from "./automobile-details/automobile-details.component";
import { RealEstateDetailsComponent } from "./real-estate-details/real-estate-details.component";
import { RealEstateListingDetailsComponent } from "./real-estate-listing-details/real-estate-listing-details.component";

const InstaCitiRoutes: Routes = [
  {
    path: "",
    component: InstacitiLandingComponent,
  },
  {
    path: ":locality/:primaryId",
    component: InstacitiListingComponent,
  },
  {
    path: ":locality/education/:handle",
    component: SchoolDetailsComponent,
  },
  {
    path: ":locality/doctor-clubs/:schoolHandle",
    component: AutomobileDetailsComponent,
  },
  {
    path: ":locality/real-estate/:handle",
    component: RealEstateDetailsComponent,
  },
  // {
  //   path: ":locality/real-estate-detail/:handle",
  //   component: RealEstateListingDetailsComponent,
  // },
  {
    path: ":handle/detail/:id",
    component: RealEstateListingDetailsComponent,
  },
  {
    path: ":locality/:primaryId/:secId",
    component: InstacitiListingComponent,
  },
  {
    path: ":locality/:primaryId/:secId/:tertId",
    component: InstacitiListingComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(InstaCitiRoutes)],
  exports: [RouterModule],
})
export class InstaCitiNewRoutingModule {}
